module.exports = __webpack_public_path__ + "img/pinglun.66e32c8d.png";